// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResults-cls1__c08e4d272629d916250c","cls2":"AutoCompleteResults-cls2__cf02c53e881270acb84b AutoCompleteResults-cls1__c08e4d272629d916250c"};